<template>
<div>
	<ul>
	  <div>
	    <van-nav-bar
	      left-text="消息通知"
	    />
	    <van-list
	      v-model="loading"
	      :finished="finished"
	      finished-text="没有更多了"
	      @load="onLoad"
	    >
	      <ArticleItem
	        v-for="(obj, index) in list"
	        :key="index"
	        :article="obj"
	      />
	    </van-list>
	  </div>
	</ul>
</div>
</template>
<script>
	import ArticleItem from '@/components/article-item/index.vue'
	import {homeShowAllXx}  from  '../../api/apitotal.js'
	export default {
	  name: 'App',
	  components: {
	    ArticleItem
	  },
	  data() {
	    return {
	      active: 0,
	      list: [],
	      loading: false,
	      finished: false,
	    }
	  },
	  created() {
	  	this.getword();
	  },
	  methods: {
		getword(){
			var sameshare=window.localStorage.getItem('phone')||null
		    homeShowAllXx('homeNews/homeShowAllXx',`Phone=${sameshare}`,'post').then(res=>{
      this.list=res.data.data.list
       console.log(res)
       
    })
		},
	    onLoad() {
	      // 异步更新数据
	      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
	      setTimeout(() => {
	        // for (let i = 0; i < 3; i++) {
	        //   this.list.push(this.list.length + 1);
	        // }
	
	        // // 加载状态结束
	        // this.loading = false;
	
	        // 数据全部加载完成
	        if (this.list.length >= 3) {
	          this.finished = true;
	        }
	      }, 1000);
	    },
	  },
	}
</script>

<style>
</style>
